import React from 'react';
import { Select, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import Button from '../../Button';
import { ProductInfo, ProductKey } from '../compareData';
import { ChevronDownIcon } from '../CompareIcons';
import styles from './CollarSelector.module.scss';

interface CollarSelectorProps {
  index: number;
  product: ProductInfo;
  options: { value: ProductKey; label: string }[];
  onSelect: (index: number, chosen: ProductKey) => void;
  onShop: (product: ProductInfo) => void;
}

/** Sticky-bar column: collar dropdown, Shop button. */
export const CollarSelector: React.FC<CollarSelectorProps> = ({ index, product, options, onSelect, onShop }) => {
  const { t } = useTranslation();
  return (
    <Stack spacing={12} miw={0}>
      {/* No visible "Select collar N" label: the dropdown already shows the chosen
          collar and sits directly under the "Compare Fi devices" heading, so the
          label only added a row of grey text. It moves to the Select's aria-label
          so the two dropdowns stay distinguishable to a screen reader — the
          generic 'select_product' announced both of them identically. */}
      <Select
        aria-label={t('compare_v2_select_collar', { number: index + 1 })}
        data={options}
        value={product.key}
        onChange={(value) => value && onSelect(index, value as ProductKey)}
        radius={999}
        rightSection={<ChevronDownIcon />}
        rightSectionWidth={44}
        classNames={{ input: styles.input, rightSection: styles.rightSection }}
      />
      <Button onClick={() => onShop(product)}>
        {t('compare_v2_shop_product', { product: t(product.shopNameKey ?? product.nameKey) })}
      </Button>
    </Stack>
  );
};
